import { Box, Typography } from '@mui/material'
import apiManagerSystem from 'api/manager-systems'
import apiManagerUser from 'api/manager-users'
import { useDialog } from 'components/DialogV3'
import DialogConfirm from 'components/DialogV3/DialogConfirm'
import { PATH_ROOT } from 'constants/api'
import { CONFIG_CODE, NS_TRANS } from 'constants/common'
import { USER_PROPERTIES } from 'constants/user'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { endSession as logout } from 'store/sessionSlice'
import { setDisabledSidebar } from 'store/layoutSlice'
import { getUserProperty } from 'utils/helpers'

const useCheck2FaStatus = (navigate) => {
    const { t } = useTranslation(NS_TRANS.MANAGE_USER)
    const { openDialog } = useDialog()
    const dispatch = useDispatch()

    const getMFACodeRequired = async (code) => { 
        try {
            const res = await apiManagerSystem.getOneConfig(code)

            return res?.data[0]?.value?.split(',') || []
        } catch (error) {
            console.log(error)
        }
    }

    const isRequired2FAEmail = async (email) => {
        const mfaDomainsRequired = await getMFACodeRequired(CONFIG_CODE.MFA_DOMAINS_REQUIRED)
        const domain = email.split("@")[1];

        return mfaDomainsRequired.includes(domain);
    }

    const isRequired2FARole = async () => {
        try {
            const res = await apiManagerUser.requiredRole2FA()

            return Boolean(res?.data?.isRequired);
        } catch (error) {
            console.log(error)
        }
    }

    const handleReject2Fa = async (isLogout) => {
        try {
            await apiManagerUser.reject2FA()

            if(isLogout) dispatch(logout())
        } catch (error) {

        }
    }

    const handleOpenDilogActive2Fa = async (data) => {
        const { email, enabled } = data
        const hasEmail = await isRequired2FAEmail(email);
        const hasRole = await isRequired2FARole();
        const isSystemAdmin = getUserProperty(USER_PROPERTIES.SYSTEM_ADMIN)

        const normalUserRejected = enabled === 2 && !hasEmail && !hasRole && !isSystemAdmin

        if(enabled === 1 || normalUserRejected) {
            return
        }

        const isRequiredMfa = hasEmail || hasRole || isSystemAdmin

        let content = 'dialog.normalUser2fa'
        let contentWarning = ''

        if(hasEmail) {
            content = 'dialog.companyUser2fa'
            contentWarning = 'dialog.companyUser2faWarning'
        }

        if(hasRole || isSystemAdmin) {
            content = 'dialog.adminUser2fa'
            contentWarning = 'dialog.adminUser2faWarning'
        }

        openDialog(DialogConfirm, {
            titleKey: 'manageUser:dialog.active2fa',
            submitKey: 'manageUser:action.activeNow',
            cancelKey: 'manageUser:action.activeLater',
            onSubmit: async () => {
                if (isRequiredMfa) {
                    dispatch(setDisabledSidebar(true))
                }
                navigate(`${PATH_ROOT}/setup-multi-factor`)
            },
            onCancel: async () => {
                await handleReject2Fa(hasEmail || hasRole || isSystemAdmin)
            },
            children: (
                <Box>
                    <Typography>{t(content)}</Typography>
                    {contentWarning && <Typography color={theme => theme.palette.primary.main}>{t(contentWarning)}</Typography>}
                </Box>
            )
        })
    }

    return {
        handleOpenDilogActive2Fa,
        handleReject2Fa,
        isRequired2FAEmail,
        isRequired2FARole
    }
}

export default useCheck2FaStatus
